import { IBookingCalendarStore } from '../../index'
import { IToggleUpdateReservation } from '../../../../actions/bookingCalendar/reservationModal/toggleReservationModal'

export default function(
  state: IBookingCalendarStore,
  action: IToggleUpdateReservation,
): IBookingCalendarStore {
  if ('gtag' in window) {
    ;(window as any).gtag('event', 'conversion', {
      send_to: 'AW-927657230/MadwCMewipADEI7aq7oD',
    })
  }

  return {
    ...state,
    reservationModal: {
      ...state.reservationModal,
      loading: false,
      selectedTab: 0,
      updateForm: {
        ...state.reservationModal.updateForm,
        id: action.id,
        isOpen: action.toggle,
      },
    },
  }
}
